import content from '../../content/homepage';

export function ValueProposition() {
  const { valueProposition } = content;

  return (
    <section
      id="value"
      aria-labelledby="value-heading"
      className="mx-auto max-w-5xl px-6 py-[var(--spacing-section-md)] md:px-12 md:py-[var(--spacing-section-lg)]"
    >
      <h2
        id="value-heading"
        className="mb-10 text-center font-sans text-[17.08px] tracking-[var(--tracking-eyebrow)] text-[color:var(--color-muted)] uppercase md:mb-12 md:text-[19.52px]"
      >
        {valueProposition.eyebrow}
      </h2>

      <p className="font-body mx-auto max-w-3xl text-center text-xl leading-relaxed text-[color:var(--color-foreground)]/90 md:text-2xl">
        {valueProposition.description}
      </p>

      <div className="mt-16 grid grid-cols-1 gap-12 md:mt-20 lg:grid-cols-3 lg:gap-16">
        {valueProposition.benefits.map((benefit) => (
          <div key={benefit.title} className="text-center lg:text-left">
            <h3 className="mb-4 font-sans text-lg tracking-[var(--tracking-button)] text-[color:var(--color-foreground)] uppercase">
              {benefit.title}
            </h3>
            <p
              className="font-body text-base leading-relaxed text-[color:var(--color-foreground)]/75 md:text-lg [&_a]:text-[color:var(--color-accent)] [&_a]:underline [&_a]:decoration-[color:var(--color-accent)]/50 [&_a]:underline-offset-2 hover:[&_a]:text-[color:var(--color-accent-hover)]"
              dangerouslySetInnerHTML={{ __html: benefit.description }}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
